<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <div
      class="projects-gallery mt-34 fadeUp"
      v-if="_.get(imageData, 'images')"
      :class="[animate ? 'animate' : '', altGallery ? 'altGallery' : '']"
    >
      <h3 class="font-21 noto-semibold">
        {{ _.get(imageData, "images_list_head") }}
      </h3>

      <!-- <h2 class="font-21 noto-semibold">{{ _.get(imageData, "title") }}</h2>
      <span>{{ _.get(imageData, "teaser") }}</span> -->

      <section class="layout-images grid-box mt-21" v-if="getGallery">
        <div
          class="image-container"
          v-for="(item, index) in getGallery"
          :key="index"
          @click="openGallery(index)"
        >
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="_.get(item, 'devices.mobile')"
              />
              <source
                media="(max-width: 1023px)"
                :srcset="_.get(item, 'devices.tablet')"
              />
              <img
                :src="_.get(item, 'devices.desktop')"
                :alt="_.get(item, 'title')"
                class="img-absolute"
              />
            </picture>

            <div class="gradient"></div>
          </div>
          
          <h4 class="img-title noto-semibold" v-if="_.get(item, 'title')">
            {{ _.get(item, "title") }}
          </h4>
        </div>
      </section>

      <div id="lightgallery" v-if="getGallery.length > 0">
        <portal to="popup">
          <LightGallery
            :images="getGallery"
            :index="index"
            :disable-scroll="true"
            @close="index = null"
          />
        </portal>
      </div>
    </div>
  </intersect>
</template>

<script>
import AliMixin from "@/mixins/ali";
import Intersect from "vue-intersect";
export default {
  mixins: [AliMixin],
  props: {
    imageData: {
      type: Object,
    },
    altGallery: {
      type: Boolean,
    },
  },
  components: { Intersect },
  data() {
    return {
      animate: false,
      index: null,
    };
  },
  computed: {
    getGallery() {
      if (this.altGallery) {
        return this.imageData.images
      }
      
      return this.imageData.images.slice(1);
    },
  },
  methods: {
    openGallery(index) {
      this.index = index;
    },
  },
  mounted() {
    this.startLightGallery({
      // youtubePlayerParams: {
      //   autoplay: 1,
      // },
      // autoplayFirstVideo: true,
      // autoplayControls: false,
    });
  },
};
</script>

<style>
.projects-gallery .grid-box {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 20px;
}

.projects-gallery .image-container {
  margin: 0;
  cursor: pointer;
}

.projects-gallery .img-box {
  padding-top: 62%;
}

.projects-gallery.altGallery .gradient {
  display: none;
}

@media (max-width: 1023px) {
  .projects-gallery .grid-box {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .projects-gallery .grid-box {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
